import Vue from "vue";
import Router from "vue-router";

import MainLayout from "@/views/layouts/Main";
import AuthLayout from "@/views/layouts/AuthLayout";
import StaticLayout from "@/views/layouts/StaticLayout";

import Finance from "@/views/Finance";
import Instruction from "@/views/Instruction";
import Stock from "@/views/Stock";
import Report from "@/views/Report";
import Pay from "@/views/Pay";
//  ---------------------------------------------------------------  Profile Section
import Profile from "@/views/Profile/";
import Profile__Docs from "@/components/profile/Documents";
import Profile__SettingsPassword from "@/components/profile/password-change";

import Overview from "@/components/finance/tabs/Overview";
import Portfolio from "@/components/finance/tabs/Portfolio";
import Cash from "@/components/finance/tabs/Cash";
import Debts from "@/components/finance/tabs/Debts";
import Transactions from "@/components/finance/tabs/Transactions";
import Analysis from "@/components/finance/tabs/Analysis";
import Unsubscribe from "@/views/static/Unsubscribe";

//  ---------------------------------------------------------------  Auth Section
import Login from "@/views/auth/Login";
import Recovery from "@/views/auth/Recovery";
import RecoveryByEmail from "@/views/auth/RecoveryByEmail";
import PasswordUpdateForm from "@/components/register_kyc/common/PasswordUpdateForm.vue";
//  ---------------------------------------------------------------  Register Section
import Register from "@/views/auth/Register";
import IdentificationForm from "@/components/register_kyc/form_steps_LE/01_LE_IdentificationForm.vue";
import GeneralForm from "@/components/register/forms/GeneralForm";
//  ---------------------------------------------------------------  Register Section / Person Entity
import ChooseRegistrationForm from "@/components/register_kyc/common/ChoooseRegistrationForm.vue";
import BasicThank from "@/components/register/thanks/BasicThank";

import GeneralInfo from "@/components/register_kyc/form_steps_PE/01_GeneralInfoForm.vue";
import WorkInfoForm from "@/components/register_kyc/form_steps_PE/02_0_WorkInfoForm.vue";
import IndividualEntreprenuer from "@/components/register_kyc/form_steps_PE/02_1_IndividEntrepreneurForm.vue";

import RepresentativesForm from "@/components/register_kyc/form_steps_PE/03_0_RepresentativesPage.vue";
import ListRepresentativesForm from "@/components/register_kyc/form_steps_PE/03_1_ListRepresentativesForm.vue";
import AddRepresentativesForm from "@/components/register_kyc/form_steps_PE/03_2_RepresentativeBlockForm.vue";

import AddressInfoForm from "@/components/register_kyc/form_steps_PE/04_AddressInfoForm.vue";
import IncomeInfoForm from "@/components/register_kyc/form_steps_PE/05_IncomeInfoForm.vue";
import ComemrcialConditionsForm from "@/components/register_kyc/form_steps_PE/06_CommercialConditionsForm.vue";
import FileUploadForm from "@/components/register_kyc/form_steps_PE/07_FileUploadForm.vue";

import RegisterFinish from "@/components/register_kyc/form_steps_PE/08_RegisterFinish.vue";
import RegisterFailed from "@/components/register_kyc/form_steps_PE/10_RegisterRequestFailed.vue";
import SignInProgress from "@/components/register_kyc/form_steps_PE/09_SignInProgress.vue";

import ClientApprovalForm from "@/components/register_kyc/form_steps_PE/08_ClientApprovalForm.vue";
//  ---------------------------------------------------------------  Register Section / Legal Entity
import RegisterDataForm from "@/components/register_kyc/form_steps_LE/02_RegisterDataForm.vue";
import LicenseDataForm from "@/components/register_kyc/form_steps_LE/03_LicenseDataForm.vue";
import TaxResidencyForm from "@/components/register_kyc/form_steps_LE/04_TaxResidencyForm.vue";

import ContorlBodyView from "@/components/register_kyc/form_steps_LE/06_0_ContorlBodyView.vue";
import ControlBodiesList from "@/components/register_kyc/form_steps_LE/06_0_ControlBodiesList.vue";
import ControlBodyForm from "@/components/register_kyc/form_steps_LE/06_1_СontrolBodyForm.vue";
import ControlMemberForm from "@/components/register_kyc/form_steps_LE/06_2_ControlMemberForm.vue";

import LegalBranches from "@/components/register_kyc/form_steps_LE/07_LegalBranches.vue";

import OwnersDataForm from "@/components/register_kyc/form_steps_LE/05_OwnersDataForm.vue";

import store from "./store/index";
import FhsCookies from "./services/cookies";
//  ---------------------------------------------------------------  404
import NotFoundPage from "@/views/404.vue";

Vue.use(Router);

const route = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: MainLayout,
      children: [
        {
          path: "finance",
          component: Finance,
          // Пути для табов, находящихся на главное странице
          children: [
            {
              path: "",
              name: "finance-overview",
              component: Overview
            },
            {
              path: "securities",
              name: "finance-securities",
              component: Portfolio
            },
            {
              path: "cash",
              name: "finance-cash",

              component: Cash
            },
            {
              path: "debts",
              name: "finance-debts",
              component: Debts
            },
            {
              path: "transactions",
              name: "finance-transactions",
              component: Transactions
            },
            {
              path: "analysis",
              component: Analysis
            }
          ]
        },
        {
          path: "instruction",
          name: "instruction",
          component: Instruction
        },
        {
          path: "stock",
          component: Stock
        },
        {
          path: "report",
          component: Report
        },
        {
          path: "profile",
          name: "profile",
          component: Profile,
          children: [
            {
              path: "docs",
              name: "profile-docs",
              component: Profile__Docs
            },
            {
              path: "password",
              name: "profile-settings-password",
              component: Profile__SettingsPassword
            }
          ]
        }
      ]
    },
    {
      path: "/auth",
      component: AuthLayout,
      children: [
        {
          path: "login",
          name: "auth-login",
          component: Login
        },
        {
          path: "recovery",
          name: "auth-recovery",
          component: Recovery
        },
        {
          path: "recovery-by-email",
          name: "auth-recovery-by-email",
          component: RecoveryByEmail
        },
        {
          path: "register",
          name: "auth-register",
          component: Register,
          beforeEnter: (to, from, next) => {
            store.commit("setRegistrationStep", 1);
            next();
          },
          children: [
            //  Basics -----------------------------------------------------------------------------------
            {
              path: "password-update/:code",
              name: "password-update",
              component: PasswordUpdateForm
            },
            {
              path: "main-form",
              name: "register-choose",
              component: ChooseRegistrationForm,
              children: [
                {
                  path: "",
                  name: "register-pe",
                  component: GeneralForm
                },
                {
                  path: "legal-entity",
                  name: "register-le",
                  component: IdentificationForm
                }
              ]
            },
            {
              path: "basic-thank",
              name: "register-index-thank",
              component: BasicThank
            },
            //  Register / Person Entity  -----------------------------------------------------------------------------------
            {
              path: "general-info",
              name: "general-info",
              component: GeneralInfo,
              beforeEnter: (to, from, next) => {
                store.commit("setRegistrationStep", 1);
                next();
              }
            },
            {
              path: "work-info",
              name: "work-info",
              component: WorkInfoForm
            },
            {
              path: "individual-entrepreneur",
              name: "individual-entrepreneur",
              component: IndividualEntreprenuer
            },
            {
              path: "representatives-info",
              name: "representatives-info",
              component: RepresentativesForm,
              children: [
                {
                  path: "",
                  name: "representatives-info-list",
                  component: ListRepresentativesForm
                },
                {
                  path: "form/:rep_type/",
                  name: "representatives-form",
                  component: AddRepresentativesForm,
                  beforeEnter: (to, from, next) => {
                    if (
                      to.params.rep_type === "representative" ||
                      to.params.rep_type === "beneificiar"
                    ) {
                      next();
                    } else {
                      next(from);
                    }
                  }
                },
                {
                  path: "form/:rep_type/:rep_index",
                  name: "representatives-form-edit",
                  component: AddRepresentativesForm,
                  beforeEnter: (to, from, next) => {
                    if (
                      to.params.rep_index !== undefined ||
                      to.params.rep_index !== null
                    ) {
                      next();
                    } else {
                      next(from);
                    }
                  }
                }
              ]
            },
            {
              path: "address-info",
              name: "address-info",
              component: AddressInfoForm
            },
            {
              path: "income-info",
              name: "income-info",
              component: IncomeInfoForm,
              beforeEnter: (to, from, next) => {
                if (store.getters.isUserLegal) {
                  store.commit("setRegistrationStep", 3);
                } else {
                  store.commit("setRegistrationStep", 2);
                }
                next();
              }
            },
            {
              path: "commercial-conditions",
              name: "commercial-conditions",
              component: ComemrcialConditionsForm,
              beforeEnter: (to, from, next) => {
                if (store.getters.isUserLegal) {
                  store.commit("setRegistrationStep", 4);
                } else {
                  store.commit("setRegistrationStep", 3);
                }
                next();
              }
            },
            {
              path: "file-upload",
              name: "file-upload",
              beforeEnter: (to, from, next) => {
                store.commit("setRegistrationStep", 4);
                next();
              },
              component: FileUploadForm
            },
            {
              path: "finish",
              name: "register-finish",
              component: RegisterFinish,
              beforeEnter: (to, from, next) => {
                store.commit("setRegistrationStep", 5);
                next();
              }
            },
            {
              path: "failed",
              name: "register-failed",
              component: RegisterFailed
            },
            {
              path: "sign-inprogress",
              name: "sign-inprogress",
              component: SignInProgress
            },
            {
              path: "client-approval",
              name: "client-approval",
              component: ClientApprovalForm
            },
            //  Register / Person Entity  -----------------------------------------------------------------------------------
            {
              path: "legal-reg",
              name: "legal-entity-register",
              component: RegisterDataForm,
              beforeEnter: (to, from, next) => {
                store.commit("setRegistrationStep", 1);
                next();
              }
            },
            {
              path: "legal-license",
              name: "legal-entity-license",
              component: LicenseDataForm
            },
            {
              path: "legal-tax-residency",
              name: "legal-tax-residency",
              component: TaxResidencyForm
            },
            {
              path: "legal-owners",
              name: "legal-owners",
              component: OwnersDataForm
            },
            {
              path: "legal-control",
              component: ContorlBodyView,
              beforeEnter: (to, from, next) => {
                store.commit("setRegistrationStep", 2);
                next();
              },
              children: [
                {
                  path: "",
                  name: "legal-control-list",
                  component: ControlBodiesList
                },
                {
                  path: ":body_type/:control_id",
                  name: "legal-control-form-detail",
                  component: ControlBodyForm
                },
                {
                  path: ":body_type/:control_id/member",
                  name: "legal-member-form",
                  component: ControlMemberForm
                },
                {
                  path: ":body_type/:control_id/member/:member_id",
                  name: "legal-member-form-detail",
                  component: ControlMemberForm
                }
              ]
            },
            {
              path: "legal-branches",
              name: "legal-branches",
              component: LegalBranches
            }
          ]
        }
      ]
    },
    {
      path: "/static",
      name: "static",
      component: StaticLayout,
      children: [
        {
          path: "unsubscribe",
          component: Unsubscribe
        }
      ]
    },
    {
      path: "/pay",
      component: Pay
    },
    {
      path: "*",
      component: NotFoundPage
    }

    // Пример подключения динамического компонента
    // {
    //   // path: '/about',
    //   // name: 'about',
    //   // // route level code-splitting
    //   // // this generates a separate chunk (about.[hash].js) for this route
    //   // // which is lazy-loaded when the route is visited.
    //   // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
});

route.beforeEach((to, from, next) => {
  let systemStatus = parseInt(FhsCookies.getItem("systemStatus"));
  // Если пользователь не авторизован
  if (!store.getters.isLoggedIn) {
    let auth_links = [
      "register-index-thank",
      "register-choose",
      "register-pe",
      "register-le",
      "auth-login",
      "auth-recovery",
      "auth-recovery-by-email",
      "auth-recovery-success",
      "auth-recovery-error",
      "password-update"
    ];
    // направляется в AUTH
    if (auth_links.indexOf(to.name) !== -1 && to.name !== undefined) {
      next();
    } else if (from.path.includes("password-update")) {
      next({ name: "password-update" });
    } else {
      console.log(from);
      next({ name: "auth-login" });
    }
  } else {
    // Проверка значения статуса
    // console.log(systemStatus);
    if (systemStatus !== null && systemStatus >= 0 && systemStatus <= 50) {
      // status  == 10
      if (systemStatus === 10) {
        if (to.path.includes("finish")) {
          next();
        } else {
          next({ name: "register-finish" });
        }
      }
      // status  == 20
      else if (systemStatus === 20) {
        if (to.path.includes("client-approval")) {
          next();
        } else {
          next({ name: "client-approval" });
        }
      }
      // status  == 30
      else if (systemStatus === 30) {
        if (to.path.includes("sign-inprogress")) {
          next();
        } else {
          next({ name: "sign-inprogress" });
        }
      }
      // Cтатус == 40
      else if (systemStatus === 40) {
        // console.log(to);
        if (to.path.includes("auth")) {
          next({ name: "finance-overview" });
        } else {
          next();
        }
      }
      // Cтатус == 50
      else if (systemStatus === 50) {
        if (to.path.includes("failed")) {
          next();
        } else {
          next({ name: "register-failed" });
        }
      } else {
        // Cтатус 0 < 40 : В регистрации
        if (
          to.path.includes("register") &&
          to.name !== "register-index" &&
          to.name !== "register-index-thank"
        ) {
          next();
        } else {
          // Cтатус 0 < 40 : В других страницах
          if (store.getters.isUserLegal) {
            next({ name: "legal-entity-register" });
          } else {
            next({ name: "general-info" });
          }
        }
      }
    } // Запршиваем статус если нету
    else {
      getUserStatus
        .then(() => {
          next();
        })
        .catch(() => {
          next({ name: "auth-login" });
        });
    }
    store.dispatch("fetchUserProfile");
  }
});

const getUserStatus = new Promise((resolve, reject) => {
  if (store.getters.isLoggedIn) {
    store.dispatch("getUserSystemStatus").then(res => {
      // Cтатус получен
      if (res.data.status) {
        store.commit("setUserSystemStatus", res.data.result.system_status);
        resolve(store.getters.system_status);
      } else {
        // reject(res);
        // Cтатуса нету
      }
    });
  }
});

export default route;
